import React from "react";
import "./RecruiterPage.css";
import recruiterVisual from "../Images/recruitergif.jpg"; // Main image
import talentImage from "../Images/Talentacquisition.png"; // Floating image
import pipelineImage from "../Images/RecruiterAI.avif"; // Pipeline image
import { Link } from 'react-router-dom';

const RecruiterHeroFinal = () => {
  return (
    <div className="recruiterfinal-wrapper container py-5">
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {/* Section 1: HIRE SMARTER */}
      <div className="row align-items-center recruiterfinal-content-row">
        {/* Left Side */}
        <div className="col-md-6 recruiterfinal-text-side">
          <p className="req-label">HIRING MANAGERS</p>
          <h2 className="recruiterfinal-heading">Hire Smarter</h2>
          <h2 className="recruiterfinal-Subheading">with Recruiter Pro</h2>
          <p className="recruiterfinal-description">
            Unlock top talent faster with intelligent automation, seamless team collaboration,
            and data-driven hiring insights — all integrated into one powerful recruitment platform.
          </p>
          <p className="recruiterfinal-description">
            Streamline every stage of your hiring journey — from sourcing to onboarding — with precision and speed.
            Empower your HR teams with tools designed for smarter decisions, reduced time-to-hire, and exceptional candidate experiences.
          </p>

          <div className="recruiterfinal-button-grid mt-4">
            <button className="recruiterfinal-btn">AI Screening Tools</button>
            <button className="recruiterfinal-btn">Real Time Team Feedback</button>
            <button className="recruiterfinal-btn">Advanced Analytics</button>
            <button className="recruiterfinal-btn">Smart Candidate Matching</button>
          </div>

          <div className="recruiterfinal-btn-row">
            <a
              href="https://jobs.skillshap.com/employer/account/signup"
              target="_blank"
              rel="noopener noreferrer"
            >
            <button className="recruiterfinal-btn-secondary">Post Job Free</button>
            </a>
            <Link to="/BookDemoForm"><button className="recruiterfinal-btn-secondary">Book a Demo</button></Link>
          </div>
        </div>

        {/* Right Side */}
        <div className="col-md-6 recruiterfinal-image-side">
          <img src={recruiterVisual} alt="Recruiter Visual" className="img-fluid recruiterfinal-img" />
        </div>
      </div>

      {/* Section 2: STREAMLINED TALENT ACQUISITION */}
      <div className="row align-items-center recruiterfinal-talentspot mt-5">
        {/* Right Side Image */}
        <div className="col-md-6">
          <img src={talentImage} alt="Talent Acquisition" className="talent-img img-fluid" />
        </div>

        {/* Right Side Content */}
        <div className="col-md-6 talent-content">
          <h2 className="tagbox-title">
            <span className="title">Streamlined </span> Talent Acquisition</h2>

          {/* <p className="tagbox-subtext">Eliminate complexity from hiring</p> */}
          <p className="tagbox-highlight">
            <span className="highlighted-link">SkillsHap’s AI-powered solutions</span> help businesses identify and engage top-tier talent with speed, accuracy, and efficiency.
          </p>
          <p className="tagbox-highlight01">They minimize manual screening efforts and enhance collaboration across hiring teams.
            With actionable insights and intelligent automation, organizations can make faster, smarter hiring decisions at scale.
          </p>
          <div className="talent-btn-center">
            <button className="tagbox-btn">Talk To Us</button>
          </div>
        </div>
      </div>
      {/* Empowering Section */}
      <div className="empowering-wrapper container">
        <h3 className="empowering-heading">
          <span className="highlighted-text">"Empowering Enterprises</span> to Hire Smarter and Faster."
        </h3>
        <p className="empowering-description">
          SkillsHap’s AI-driven recruitment platform empowers your team to attract qualified candidates,
          streamline screening, and fill roles faster — all without expanding your hiring bandwidth.
          We help growing businesses scale with speed, precision, and confidence.
        </p>
      </div>
      <div className="talentpipeline-wrapper container">
        <div className="row align-items-center talentpipeline-row">
          {/* Left Side - Text */}
          <div className="col-md-6 talentpipeline-text">
            <h4 className="talentpipeline-heading">
              <span className="highlight-blue">Tap Into a Qualified</span>, Diverse Talent Pipeline
            </h4>
            <p className="talentpipeline-description">
              Gain access to a highly engaged candidate network—backed by performance data.
              Over 300,000 professionals on Skillshap come from top-tier institutions and diverse backgrounds.
              With 4x higher response rates than traditional platforms, Skillshap ensures faster, smarter connections with top talent.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="col-md-6 talentpipeline-image">
            <img src={pipelineImage} alt="Diverse Talent Pipeline" className="img-fluid" />
          </div>
        </div>
      </div>

    </div>
  );
};

export default RecruiterHeroFinal;
